import Lightbox from 'CoreComponents/lightbox';

if (document.querySelector('.list-media__item a')) {
  new Lightbox();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/lightbox.js